/** Serialize / parse persisted chat label filter (single legacy string or JSON array for multi-select). */

export function parseChatUsersLabelFilter(raw: string | null | undefined): string[] {
  if (raw == null || raw === '') return [];
  const trimmed = raw.trim();
  if (trimmed.startsWith('[')) {
    try {
      const parsed = JSON.parse(trimmed) as unknown;
      if (Array.isArray(parsed)) {
        return parsed.filter((x): x is string => typeof x === 'string');
      }
    } catch {
      /* fall through */
    }
  }
  return [raw];
}

export function serializeChatUsersLabelFilter(labels: string[]): string | null {
  if (labels.length === 0) return null;
  if (labels.length === 1) return labels[0];
  return JSON.stringify(labels);
}
